import type { FirestoreTimestamp } from "../types"

const pad = (n: number): string => String(n).padStart(2, "0")

const isSameDay = (a: Date, b: Date): boolean =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate()

/**
 * Messenger-style conversation date for the Readings list (per Figma): the time
 * `HH:mm` when the message is from today, `Yesterday` when from the previous
 * calendar day, else the date `DD.MM.YYYY`. Returns "" for a missing/invalid
 * timestamp so the caller can render nothing.
 */
export function formatThreadDate(ts: FirestoreTimestamp | undefined, now: Date = new Date()): string {
  if (!ts || typeof ts._seconds !== "number") return ""
  const date = new Date(ts._seconds * 1000)
  if (Number.isNaN(date.getTime())) return ""

  if (isSameDay(date, now)) return `${pad(date.getHours())}:${pad(date.getMinutes())}`

  const yesterday = new Date(now)
  yesterday.setDate(now.getDate() - 1)
  if (isSameDay(date, yesterday)) return "Yesterday"

  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`
}
